import type { ReferralFunnelDay } from "@decibeltrade/sdk";

import { fillDailyWindow } from "../daily-window";

/** One day column of the funnel chart, oldest first. */
export interface FunnelBar {
  dayStartUnixMs: number;
  signUps: number;
  firstDeposits: number;
}

/**
 * Funnel chart columns. Ordering, gap filling and window padding all live in
 * [`fillDailyWindow`]; this only maps a day to its two counts.
 */
export function toFunnelBars(days: readonly ReferralFunnelDay[], windowDays: number): FunnelBar[] {
  return fillDailyWindow(days, windowDays, (dayStartUnixMs, present) => ({
    dayStartUnixMs,
    signUps: present?.sign_ups ?? 0,
    firstDeposits: present?.first_deposits ?? 0,
  }));
}
